(function () {
  'use strict';

  var MOBILE_BP = 768;

  function buildStickySelect() {
    if (window.innerWidth >= MOBILE_BP) return;

    var stickyAtc = document.querySelector('sticky-atc');
    if (!stickyAtc || stickyAtc.querySelector('.fs-sticky-size')) return;

    var sizeSelector = document.querySelector('.option-selector[data-option="Size"]');
    if (!sizeSelector) return;

    var allOptions = Array.from(sizeSelector.querySelectorAll('.js-option[data-value]'));
    if (allOptions.length === 0) return;

    // Build native select
    var wrap = document.createElement('div');
    wrap.className = 'fs-sticky-size';

    var sel = document.createElement('select');
    sel.className = 'fs-sticky-size__select';
    sel.setAttribute('aria-label', 'Select size');

    allOptions.forEach(function (opt) {
      var o = document.createElement('option');
      o.value = opt.dataset.value;
      o.textContent = opt.textContent.trim();
      if (opt.getAttribute('aria-selected') === 'true') o.selected = true;
      sel.appendChild(o);
    });

    wrap.appendChild(sel);

    // Insert before the buttons div
    var buttonsDiv = stickyAtc.querySelector('.sticky-atc__buttons');
    if (buttonsDiv) stickyAtc.insertBefore(wrap, buttonsDiv);

    // Sticky select → main form: click matching .js-option button
    sel.addEventListener('change', function () {
      var val = this.value;
      var targetOpt = Array.from(sizeSelector.querySelectorAll('.js-option[data-value]'))
        .find(function (o) { return o.dataset.value === val; });
      if (targetOpt) targetOpt.click();
    });

    // Main form → sticky select: watch variant title in sticky bar
    var varTitle = stickyAtc.querySelector('.sticky-atc__details__variant__title');
    if (varTitle) {
      new MutationObserver(function () {
        var selected = Array.from(sizeSelector.querySelectorAll('.js-option[data-value]'))
          .find(function (o) { return o.getAttribute('aria-selected') === 'true'; });
        if (selected && sel.value !== selected.dataset.value) {
          sel.value = selected.dataset.value;
        }
      }).observe(varTitle, { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(buildStickySelect, 400); });
  } else {
    setTimeout(buildStickySelect, 400);
  }
})();
